// extracted by mini-css-extract-plugin
module.exports = {"list_tab":"index_list_tab__YEUSN"};